module.exports = require('./configureStore.prod');